import { useMemo } from 'react'
import { Swap } from '@pancakeswap/uikit'
import { PageMeta } from 'components/Layout/Page'
import { EXCHANGE_DOCS_URLS } from 'config/constants'
import useTheme from 'hooks/useTheme'
import { palette } from 'views/Home/colors'

const Page: React.FC<
  React.PropsWithChildren<{
    removePadding?: boolean
    hideFooterOnDesktop?: boolean
    noMinHeight?: boolean
    helpUrl?: string
  }>
> = ({
  children,
  removePadding = false,
  hideFooterOnDesktop = false,
  noMinHeight = false,
  helpUrl = EXCHANGE_DOCS_URLS,
  ...props
}) => {
  const { theme } = useTheme()
  const p = palette(theme.isDark)

  const bgGlow = useMemo(
    () =>
      theme.isDark
        ? `radial-gradient(ellipse 70% 45% at 50% 0%, rgba(32,64,128,0.45) 0%, ${p.bg} 65%)`
        : `radial-gradient(ellipse 70% 45% at 50% 0%, rgba(61,174,245,0.10) 0%, ${p.bg} 65%)`,
    [theme.isDark, p.bg],
  )

  return (
    <>
      <PageMeta />
      <Swap.Page
        removePadding={removePadding}
        noMinHeight={noMinHeight}
        hideFooterOnDesktop={hideFooterOnDesktop}
        helpUrl={helpUrl}
        style={{ background: bgGlow }}
        {...props}
      >
        {children}
      </Swap.Page>
    </>
  )
}

export default Page
